module.exports = __webpack_public_path__ + "static/media/logo-cidadania-ja.91e98b02.png";